import React, { useState, useRef, useEffect } from 'react';
import { useCart } from '../../contexts/CartProvider';
import { useAuth } from '../../contexts/AuthContext';
import { useSaldo } from '../../contexts/SaldoContext';
import styles from './style.module.scss';
import { BsFillCreditCardFill } from 'react-icons/bs';
import { FaPix } from 'react-icons/fa6';
import { FiCreditCard, FiDollarSign } from 'react-icons/fi';
import CreditoPrePago from '../CreditoPrePago';
import CartaoCredito from '../CartaoCredito';
import { toast } from 'react-toastify';
import Pix from '../Pix';
import logo from '../../assets/logo.png';

const StepPagamento = ({ items, handleNextStep, showPrePago = true }) => {
  const { isAuthenticated, user } = useAuth();
  const [couponCode, setCouponCode] = useState('');
  const { validateCoupon } = useCart();
  const { saldo } = useSaldo();
  const [methodPayment, setMethodPayment] = useState('prePago');
  const titleRef = useRef(null);

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const validarCupon = async (isPix = false) => {
    if (couponCode.toLowerCase() === 'pix10') {
      if (isPix) {
        validateCoupon(couponCode);
        return true;
      } else {
        toast.warn('Cupom não aplicável a esta modalidade de pagamento', {
          position: 'top-right',
          autoClose: 5000,
          theme: 'light',
        });
        return false;
      }
    }
    const cupomValidado = await validateCoupon(couponCode);
    return cupomValidado;
  };

  const handleMethodPayment = (method) => {
    setMethodPayment(method);
  };

  const formatarComoMoeda = (valor) => {
    if (!valor) return 'R$ 0,00';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const paymentMethods = [
    {
      id: 'prePago',
      title: 'Crédito Pré-Pago',
      subtitle: 'Use seu saldo da plataforma',
      icon: <img src={logo || "/placeholder.svg"} alt='logo' className={styles.logoIcon} />,
      disabled: !user || user.saldo <= 0,
      balance: user ? formatarComoMoeda(saldo) : 'N/A',
      show: showPrePago
    },
    {
      id: 'cartao',
      title: 'Cartão de Crédito',
      subtitle: 'Confirmação imediata',
      icon: <FiCreditCard />,
      disabled: false,
      show: true
    },
    {
      id: 'pix',
      title: 'PIX',
      subtitle: 'Confirmação imediata',
      icon: <FaPix />,
      disabled: false,
      show: true
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 ref={titleRef} className={styles.title}>
          Escolha a forma de pagamento
        </h1>
        <p className={styles.subtitle}>
          Selecione o método de pagamento de sua preferência
        </p>
      </div>

      <div className={styles.paymentMethods}>
        {paymentMethods
          .filter(method => method.show)
          .map((method) => (
            <button
              key={method.id}
              disabled={method.disabled}
              className={`${styles.paymentCard} ${
                methodPayment === method.id ? styles.selected : ''
              } ${method.disabled ? styles.disabled : ''}`}
              onClick={() => !method.disabled && handleMethodPayment(method.id)}
            >
              <div className={styles.cardIcon}>
                {method.icon}
              </div>
              
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{method.title}</h3>
                <p className={styles.cardSubtitle}>{method.subtitle}</p>
                {method.balance && (
                  <div className={styles.balance}>
                    <span className={styles.balanceLabel}>Saldo atual:</span>
                    <span className={styles.balanceValue}>{method.balance}</span>
                  </div>
                )}
              </div>

              {methodPayment === method.id && (
                <div className={styles.selectedIndicator}>
                  <div className={styles.checkmark}>✓</div>
                </div>
              )}
            </button>
          ))}
      </div>

      <div className={styles.paymentContent}>
        {methodPayment === 'prePago' && (
          <CreditoPrePago
            validarCupon={validarCupon}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            items={items}
            handleNextStep={handleNextStep}
          />
        )}
        {methodPayment === 'cartao' && (
          <CartaoCredito
            validarCupon={validarCupon}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            items={items}
            handleNextStep={handleNextStep}
          />
        )}
        {methodPayment === 'pix' && (
          <Pix
            validarCupon={validarCupon}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            items={items}
            handleNextStep={handleNextStep}
          />
        )}
      </div>
    </div>
  );
};

export default StepPagamento;
